import { render, staticRenderFns } from "./PlayerRegistration.vue?vue&type=template&id=539e4f0d"
import script from "./PlayerRegistration.vue?vue&type=script&lang=js"
export * from "./PlayerRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports